<template>
  <div>
    <mtd-row>
      <mtd-col :span="24" class="height-full ">
        <mtd-announcement
          title="公告信息"
          type="info"
          show-icon>
          <span>{{ $getText('operation_alarm_mobile_title', '请关注告警内容，我们将持续保障您的数据安全。如有疑问请大象联系') }}<a href="https://x.sankuai.com/bridge/chat?pubid=137444543861" target="_blank">{{ $getText('operation_alarm_mobile_pub_mis', '数据安全小助手') }}</a>。
          </span>
        </mtd-announcement>
      </mtd-col>
    </mtd-row>
    <mtd-row class="height-64 line-height-64">
      <mtd-col :span="24" class="height-full">
        <span class="page-head-title" style="margin-left: 12px;">{{ $getText('operation_alarm_title_detail', '告警通知') }}</span>
        <mtd-tag theme="green" type="pure" class="page-head-title-tag"
                 v-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 1">
          {{ $getText('operation_alarm_status_only_reminder', '仅告警提醒') }}
        </mtd-tag>
        <mtd-tag theme="red" type="pure" class="page-head-title-tag"
                 v-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 2 && alarm_info.beAlertedMis === alarm_info.recipient">
          {{ $getText('operation_alarm_status_self_feedback', '待本人反馈') }}
        </mtd-tag>
        <mtd-tag theme="red" type="pure" class="page-head-title-tag"
                 v-else-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 2 && (alarm_info.supervisor === alarm_info.recipient || (alarm_info.noticeConfig && alarm_info.noticeConfig.noticeObject === 3))">
          {{ $getText('operation_platform_status_supervisor_feedback', '待相关方反馈') }}
        </mtd-tag>
        <mtd-tag theme="red" type="pure" class="page-head-title-tag"
                 v-else-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 2">
          {{ $getText('operation_platform_status_cc_feedback', '待抄送人反馈') }}
        </mtd-tag>
        <mtd-tag theme="red" type="pure" class="page-head-title-tag"
                 v-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 3">
          {{ $getText('operation_alarm_status_supersivor_confirm', '待相关方确认') }}
        </mtd-tag>
        <mtd-tag theme="red" type="pure" class="page-head-title-tag"
                 v-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 6">
          {{ $getText('operation_alarm_status_sec_recheck', '待信安复核') }}
        </mtd-tag>
        <mtd-tag theme="green" type="pure" class="page-head-title-tag"
                 v-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 9">
          {{ $getText('operation_alarm_status_finished', '已完成') }}
        </mtd-tag>
        <mtd-tag theme="green" type="pure" class="page-head-title-tag" v-if="alarm_info.taskStatus === 100">
          {{ $getText('operation_alarm_status_finished', '已完成') }}
        </mtd-tag>
      </mtd-col>
    </mtd-row>
    <div style="padding: 0 12px">
      <mtd-row v-if="risk_summary.length !== 0" class="height-56 line-height-56">
        <mtd-col :span="24" class="height-full ">
          <span class="page-second-title">风险概览</span>
        </mtd-col>
      </mtd-row>
      <mtd-row v-if="risk_summary.length !== 0">
        <mtd-col :span="24" class="height-full ">
          <span v-html="alarm_info.content"></span>
        </mtd-col>
      </mtd-row>
      <div v-if="risk_summary.length === 0">
        <mtd-row>
          <mtd-col :span="24" class="height-full ">
            <table class="full-block-table" style="margin-top: 16px;">
              <tr class="table-row">
                <td class="td-title">{{alarm_info.targetType === 2 ? $getText('operation_alarm_column_mis', '责任人')
                  : $getText('operation_alarm_column_mis', '当事人账号') }}</td>
                <td>{{alarm_info.beAlertedMis}}</td>
              </tr>
              <tr class="table-row" ref="contentWrapper">
                <td class="td-title">{{ $getText('operation_alarm_risk_detail', '风险详情') }}</td>
                <td class="alarm_info_content">
                  <div :style="contentStyle" v-if="alarm_info.beAlertedMis === this.login_user.mis_id">
                    <span v-html="alarm_info.content"></span>
                  </div>
                  <div :style="contentStyle" v-else-if="alarm_info.supervisor === this.login_user.mis_id">
                    <span v-html="alarm_info.superiorContent || alarm_info.content"></span>
                  </div>
                  <div :style="contentStyle" v-else-if="is_cc_role">
                    <span v-html="alarm_info.ccContent || alarm_info.content"></span>
                  </div>
                  <div :style="contentStyle" v-else>
                    <span v-html="alarm_info.content"></span>
                  </div>
                  <br/><a href="javascript:void(0)"
                     v-if="isContentOverflow"
                     @click="toggleContent"
                     :style="{ color: '#007BFF'}">
                    <span>{{ showFullContent ? $getText('operation_alarm_btn_collapse', '点击收起') : $getText('operation_alarm_btn_view_all', '点击查看全部内容') }}</span>
                    <template v-if="showFullContent">
                      <i class="mtdicon mtdicon-up"></i>
                    </template>
                    <template v-else>
                      <i class="mtdicon mtdicon-down"></i>
                    </template>
                  </a>
                </td>
              </tr>
            </table>
          </mtd-col>
        </mtd-row>
        <!-- 用户反馈表单 -->
        <mtd-row v-if="appeal_show && !appeal_result_show && !file_out_show" style="margin-top: 34px;">
          <mtd-col :span="24" class="height-full ">
            <div class="feedback-reason-block">
              <div>
                <span class="page-second-title">{{ $getText('operation_alarm_title_feedback', '反馈') }}</span>
              </div>
              <div style="margin-top: 5px;">
                <mtd-form :label-width="46" label-position="top">
                  <mtd-form-item :label="text_data.reason + ':'" class="small-mtd-form-item" :helper="getDescription(appeal_type, 0)">
                    <mtd-radio-group v-model="appeal_type">
                      <mtd-radio :value="item" v-for="(item, index) in radioList" :key="index">{{ item }}</mtd-radio>
                    </mtd-radio-group>
                  </mtd-form-item>
                  <mtd-form-item label="" class="small-mtd-form-item">
                    <mtd-textarea :placeholder="text_data.feedback_tips" v-model="appeal_other_reason" style="width: 100%;"
                                  rows="3" maxlength="500" :invalid="appeal_other_reason === ''" />
                  </mtd-form-item>
                  <mtd-form-item style="margin-top: 12px">
                    <mtd-button type="primary" style="margin-right: 12px;" @click="submit_appeal_reason" :disabled="appeal_type === '' || appeal_other_reason === ''">
                      {{ $getText('operation_alarm_btn_confirm', '确定') }}
                    </mtd-button>
                    <mtd-button @click="appeal_show = false" v-if="alarm_info.rowStatus === 1">{{ $getText('operation_alarm_btn_cancel', '取消') }}</mtd-button>
                    <mtd-button @click="editCancel" v-if="alarm_info.rowType === 2 && editAppealFlag">{{ $getText('operation_alarm_btn_cancel', '取消') }}</mtd-button>
                  </mtd-form-item>
                </mtd-form>
              </div>
            </div>
          </mtd-col>
        </mtd-row>
        <!-- 外发质询用户反馈表单 -->
        <mtd-row v-if="appeal_show && !appeal_result_show && file_out_show" style="margin-top: 34px;">
          <mtd-col :span="24" class="height-full ">
            <div class="feedback-reason-block">
              <div>
                <span class="page-second-title">{{ $getText('operation_alarm_title_feedback', '反馈') }}</span>
              </div>
              <div style="margin-top: 5px;">
                <mtd-form :label-width="120" label-position="top">
                  <mtd-form-item :label="text_data.reason + ':'" class="small-mtd-form-item" :helper="getDescription(appeal_type, 0)">
                    <mtd-radio-group v-model="appeal_type">
                      <mtd-radio :value="item" v-for="(item, index) in radioList" :key="index">{{ item }}</mtd-radio>
                    </mtd-radio-group>
                  </mtd-form-item>
                  <mtd-form-item :label="text_data.send_object + ':'"  class="small-mtd-form-item mtd-form-item-required">
                    <mtd-input v-model="sendObject" style="width: 100%" :placeholder="text_data.send_object_tips"/>
                  </mtd-form-item>
                  <mtd-form-item :label="text_data.feedback_proof + ':'" class="small-mtd-form-item" :helper="text_data.feedback_proof_tips">
                    <div>
                      <mtd-upload
                        class="picture-list"
                        action="/api/task/uploadImg"
                        list-type="picture-card"
                        accept="image/*"
                        :on-success="uploadToVenus"
                        :before-remove="removePicture"
                        :on-preview="handlePictureCardPreview"
                        :file-list="files">
                        <i class="mtdicon-add" />
                      </mtd-upload>
                      <mtd-modal v-model="previewVisible">
                        <img :src="previewImageUrl"/>
                      </mtd-modal>
                    </div>
                  </mtd-form-item>
                  <mtd-form-item :label="text_data.description + ':'" class="small-mtd-form-item" required>
                    <mtd-textarea :placeholder="text_data.feedback_tips" v-model="appeal_other_reason" style="width: 100%;"
                                  rows="3" maxlength="500" />
                  </mtd-form-item>
                  <mtd-form-item style="margin-top: 12px">
                    <mtd-button type="primary" style="margin-right: 12px;" @click="submit_file_out" :disabled="file_out_disabled">
                      {{ $getText('operation_alarm_btn_confirm', '确定') }}
                    </mtd-button>
                    <mtd-button @click="appeal_show = false" v-if="alarm_info.rowStatus === 1">{{ $getText('operation_alarm_btn_cancel', '取消') }}</mtd-button>
                    <mtd-button @click="editCancel" v-if="alarm_info.rowType === 2 && editAppealFlag">{{ $getText('operation_alarm_btn_cancel', '取消') }}</mtd-button>
                  </mtd-form-item>
                </mtd-form>
              </div>
            </div>
          </mtd-col>
        </mtd-row>
        <!-- 用户反馈结果展示 -->
        <mtd-row v-if="appeal_result_show && !file_out_show" style="margin-top: 34px;">
          <mtd-col :span="24" class="height-full ">
            <span class="page-second-title">{{ self_appeal_text }}</span>
            <mtd-tag theme="red" type="pure" class="page-head-title-tag" v-if="alarm_info.visitFlag === 0">
              {{ $getText('operation_alarm_feedback_no_view', '未查看') }}
            </mtd-tag>
            <mtd-tag theme="green" type="pure" class="page-head-title-tag" v-if="alarm_info.visitFlag === 1">
              {{ $getText('operation_alarm_feedback_viewed', '已查看') }}
            </mtd-tag>
            <mtd-icon-button v-if="appeal_edit_show" class="demo-icon-btn" icon="mtdicon mtdicon-edit-o" @click="editAppeal" />
          </mtd-col>
          <mtd-col :span="24" class="height-full ">
            <table class="full-block-table" style="margin-top: 16px;margin-bottom: 9px;">
              <tr class="table-row">
                <td class="td-title">{{ $getText('operation_alarm_self_feedback_reason', '原因') }}</td>
                <td>{{alarm_info.appealType | appealTypeFilter(this.radioList)}}{{alarm_info.appealReason}}</td>
              </tr>
            </table>
          </mtd-col>
        </mtd-row>
        <mtd-row v-if="appeal_result_show && file_out_show" style="margin-top: 34px;">
          <mtd-col :span="24" class="height-full ">
            <span class="page-second-title">{{ self_appeal_text }}</span>
            <mtd-tag theme="red" type="pure" class="page-head-title-tag" v-if="alarm_info.visitFlag === 0">
              {{ $getText('operation_alarm_feedback_no_view', '未查看') }}
            </mtd-tag>
            <mtd-tag theme="green" type="pure" class="page-head-title-tag" v-if="alarm_info.visitFlag === 1">
              {{ $getText('operation_alarm_feedback_viewed', '已查看') }}
            </mtd-tag>
            <mtd-icon-button v-if="appeal_edit_show" class="demo-icon-btn" icon="mtdicon mtdicon-edit-o" @click="editAppeal" />
          </mtd-col>
          <mtd-col :span="24" class="height-full ">
            <table class="full-block-table" style="margin-top: 16px;margin-bottom: 9px;">
              <tr class="table-row">
                <td class="td-title">{{ $getText('operation_alarm_self_feedback_reason', '原因') }}</td>
                <td>{{alarm_info.appealType | appealTypeFilter(this.radioList)}}{{alarm_info.appealReason}}</td>
              </tr>
              <tr class="table-row">
                <td class="td-title">{{ $getText('operation_alarm_feedback_send_object', '发送对象') }}</td>
                <td>{{ alarm_info.sendObject }}</td>
              </tr>
              <tr class="table-row">
                <td class="td-title">{{ $getText('operation_alarm_feedback_proof', '发送记录证明') }}</td>
                <td>
                  <div style="margin-top: 16px">
                    <img :src="item" v-for="(item, index) in (!alarm_info.pictures ? [] : alarm_info.pictures.split(','))"
                         v-bind:key="index" style="width: 160px;height: 160px;cursor: pointer" @click="picturePreview(item)"/>
                  </div>
                  <mtd-modal v-model="resultPreviewModal">
                    <img :src="activeImg"/>
                  </mtd-modal>
                </td>
              </tr>
            </table>
          </mtd-col>
        </mtd-row>
        <mtd-row>
          <mtd-button v-if="appeal_edit_show && alarm_info.rowStatus === 3" class="btn-demo-item" ghost type="primary"
                      style="width: 100%;margin-bottom: 10px"
                      v-clipboard:copy="urge_url"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError">{{ $getText('operation_alarm_btn_copy_link', '复制催办链接') }}</mtd-button>
        </mtd-row>
        <!-- 领导确认表单 -->
        <mtd-row v-if="feedback_show && !feedback_result_show" style="margin-top: 34px;">
          <mtd-col :span="24" class="height-full">
            <div class="feedback-reason-block">
              <div>
                <span class="page-second-title">{{ $getText('operation_alarm_supervisor_confirm', '上级确认') }}</span>
                <span class="submit-helper">{{ $getText('operation_alarm_supervisor_tips', '请根据实际情况核实，如有隐瞒将根据阳光职场追究不诚信责任') }}</span>
              </div>
              <div style="margin-top: 5px;">
                <mtd-form :label-width="46" label-position="top">
                  <mtd-form-item :label="text_data.supervisor_confirm + ':'" class="small-mtd-form-item"  :helper="getDescription(feedback_reason, 1)">
                    <mtd-radio-group v-model="feedback_reason">
                      <mtd-radio :value="item" v-for="(item, index) in superiorRadioList" :key="index">{{ item }}</mtd-radio>
                    </mtd-radio-group>
                  </mtd-form-item>
                  <mtd-form-item :label="text_data.description" class="small-mtd-form-item">
                    <mtd-textarea :placeholder="text_data.description" v-model="feedback_other_reason" style="width: 100%;"
                                  rows="3" maxlength="500" />
                  </mtd-form-item>
                  <mtd-form-item>
                    <mtd-button type="primary" style="margin-right: 12px;" @click="submit_feedback_reason" :disabled="feedback_other_reason === '' || feedback_reason === ''">
                      {{ $getText('operation_alarm_btn_confirm', '确定') }}
                    </mtd-button>
                    <mtd-button @click="editFeedbackCancel" v-if="editFeedbackFlag">{{ $getText('operation_alarm_btn_cancel', '取消') }}</mtd-button>
                  </mtd-form-item>
                </mtd-form>
              </div>
            </div>
          </mtd-col>
        </mtd-row>
        <!-- 领导确认结果 -->
        <mtd-row v-if="feedback_result_show" style="margin-top: 34px;">
          <mtd-col :span="24" class="height-full ">
            <span class="page-second-title">{{ $getText('operation_alarm_supervisor_confirm', '上级确认') }}</span>
            <mtd-icon-button v-if="feedback_edit_show" class="demo-icon-btn" icon="mtdicon mtdicon-edit-o" @click="editFeedback" />
          </mtd-col>
          <mtd-col :span="24" class="height-full ">
            <table class="full-block-table" style="margin-top: 16px;margin-bottom: 9px;">
              <tr class="table-row">
                <td class="td-title">{{ $getText('operation_alarm_feedback_confirm', '确认') }}：</td>
                <td>{{alarm_info.feedbackReason}}</td>
              </tr>
            </table>
          </mtd-col>
        </mtd-row>
      </div>
      <div v-if="risk_summary.length !== 0">
        <mtd-row class="height-56 line-height-56">
          <mtd-col :span="24" class="height-full ">
            <span class="page-second-title">{{ $getText('operation_alarm_risk_detail', '风险详情') }}：</span>
            <mtd-button style="float: right;margin-top: 10px" class="btn-demo-item" type="primary" icon="mtdicon mtdicon-export-o" @click="export_to_excel()">导出为Excel</mtd-button>
          </mtd-col>
        </mtd-row>
        <mtd-row>
          <mtd-col class="height-full ">
            <mtd-table :data="risk_summary" size="small" :height="risk_height" bordered>
              <mtd-table-column v-for="(item,key) in risk_summary_mapping" :key="key" :prop="key" :label="item" resizable/>
            </mtd-table>
          </mtd-col>
        </mtd-row>
        <mtd-row class="height-56 line-height-56">
          <mtd-col :span="24" class="height-full ">
            <span class="page-second-title">明细日志</span>
          </mtd-col>
        </mtd-row>
        <mtd-row>
          <mtd-col class="height-full ">
            <mtd-table :data="risk_details_show" size="small" bordered>
              <mtd-table-column v-for="(item,key) in risk_details_mapping" :key="key" :prop="key" :label="item" resizable show-overflow-tooltip />
            </mtd-table>
            <mtd-pagination
              show-size-changer
              :total="risk_details.length"
              :show-total="true"
              :current-page.sync="currentPage"
              :page-size.sync="limit"
              size="small"
              @change="change_risk_details"
              style="float: right;margin-top: 13px" />
          </mtd-col>
        </mtd-row>
      </div>
    </div>
  </div>
</template>

<script>

  import moment from 'moment';
  import {mapActions} from 'vuex'
  import XLSX from 'xlsx'

  export default {
    name: "detail",
    filters: {
      dateTimeFormat(dateTime) {
        if (dateTime) {
          return moment(dateTime)
            .utcOffset(480)
            .format('YYYY-MM-DD HH:mm:ss');
        } else {
          return "";
        }
      },
      appealTypeFilter(appealType, array) {
        if (!appealType || appealType === '0') {
          return '暂未反馈';
        } else {
          return array.find(item => item === appealType) + '：';
        }
      }
    },
    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
      file_out_disabled() {
        return this.appeal_type === '' || this.appeal_other_reason === '' || this.sendObject === '';
      },
      // 催办链接
      urge_url() {
        if (this.$router.currentRoute.name === 'mobile_alarm_detail') {
          return window.location.protocol + '//' + window.location.host + '/#/alarm/' + this.alarm_id;
        } else if (this.$router.currentRoute.name === 'mobile_logout_detail') {
          return window.location.protocol + '//' + window.location.host + '/#/logout_detail/' + this.alarm_id;
        } else {
          return window.location.protocol + '//' + window.location.host + '/#/alarm/' + this.alarm_id;
        }
      },
      contentStyle() {
        return !this.showFullContent ? { 'max-height': this.maxHeight + 'px', overflow: 'hidden' } : {};
      }
    },
    data() {
      return {
        alarm_id: this.$route.params.id,
        alarm_info: {},
        // 用户反馈
        appeal_show: false,
        appeal_type: '',
        appeal_other_reason: '',
        // 外发质询用户反馈表单
        file_out_show: false,
        sendObject: '',
        files: [],
        pictureUrl: [],
        previewVisible: false,
        previewImageUrl: '',
        // 用户反馈展示
        appeal_user: '',
        appeal_result_show: false,
        appeal_edit_show: false,
        // 领导确认
        feedback_show: false,
        feedback_reason: '',
        feedback_other_reason: '',
        // 领导确认展示
        feedback_result_show: false,
        feedback_edit_show: false,
        // 风险概览表格映射和数据
        risk_summary_mapping:{},
        risk_summary:[],
        // 风险详情表格映射和数据
        risk_details_mapping:{},
        risk_details:[],
        risk_details_show:[],
        currentPage: 1,
        limit: 10,
        risk_height: '',
        editAppealFlag: false,
        editFeedbackFlag: false,
        selection:[],
        detailReason: '',
        activeImg: '',
        resultPreviewModal: false,
        radioList: ['工作需要', '不是本人操作', '不清楚原因', '其他'],
        superiorRadioList: ['情况属实', '存在异常', '其他'],
        is_cc_role: false,
        descriptionList: [],
        supervisorDescriptionList: [],
        showFullContent: false,
        isContentOverflow: false,
        maxHeight: 10000,
        text_data: {
          reason: '原因',
          description: '说明',
          add_cc_title: '添加抄送人',
          cc_list: '抄送人',
          feedback_tips: '请输入反馈信息',
          send_object: '发给了谁',
          send_object_tips: '如：同事mis、合作伙伴公司和名称等，没有可以填无',
          feedback_proof: '发送记录证明',
          feedback_proof_tips: '说明：包含文件、发送时间和接收者账号的相关截图',
          supervisor_confirm: '确认',
        }
      }
    },
    mounted: function () {
      this.text_data.reason = this.$getText('operation_alarm_self_feedback_reason', '原因');
      this.text_data.description = this.$getText('operation_alarm_feedback_description', '说明');
      this.text_data.add_cc_title = this.$getText('operation_alarm_btn_add_cc', '添加抄送人');
      this.text_data.cc_list = this.$getText('operation_alarm_cc', '抄送人');
      this.text_data.feedback_tips = this.$getText('operation_alarm_feedback_tips', '请输入反馈信息');
      this.text_data.send_object = this.$getText('operation_alarm_feedback_send_object', '发给了谁');
      this.text_data.send_object_tips = this.$getText('operation_alarm_feedback_send_object_tips', '如：同事mis、合作伙伴公司和名称等，没有可以填无');
      this.text_data.feedback_proof = this.$getText('operation_alarm_feedback_proof', '发送记录证明');
      this.text_data.feedback_proof_tips = this.$getText('operation_alarm_feedback_proof_tips', '说明：包含文件、发送时间和接收者账号的相关截图');
      this.text_data.supervisor_confirm = this.$getText('operation_alarm_feedback_confirm', '确认');

      this.init_data();
    },
    methods: {
      ...mapActions([
        'api_query_reminders_inquiries_by_id',
        'api_update_reminders_inquiries',
      ]),
      checkboxable (row) {
        if (row.governStatus !== 0) {
          return false;
        } else {
          return true;
        }
      },
      change_risk_details(current, size) {
        this.currentPage = current;
        this.limit = size;
        let temp = this.risk_details;
        let start = (this.currentPage - 1) * this.limit;
        let end = this.currentPage * this.limit;
        this.risk_details_show = temp.slice(start,end);
      },
      async init_data() {
        let response = await this.api_query_reminders_inquiries_by_id({id: this.alarm_id});
        this.alarm_info = response.data;

        let taskName = this.alarm_info.alarmName;
        if(!taskName){
          taskName = this.alarm_info.taskName;
        }
        document.title = '【' + this.$getText('operation_alarm_title_alarm', '安全告警') + '】' + this.alarm_info.beAlertedMis + '-' + taskName;

        if (this.alarm_info.cc) {
          this.is_cc_role = this.alarm_info.cc.indexOf(this.login_user.mis_id) !== -1;
        }
        if (this.alarm_info.automaticDispositionId === 14) {
          this.file_out_show = true;
        }
        if (this.alarm_info.needPicture) {
          this.file_out_show = true;
        }
        // 如果是接收人
        if (this.alarm_info.rowStatus === 2 && this.alarm_info.recipient.indexOf(this.login_user.mis_id) !== -1) {
          this.appeal_show = true;
        }
        // 如果是接收人，展示编辑反馈按钮
        if (this.alarm_info.recipient.indexOf(this.login_user.mis_id) !== -1) {
          this.appeal_edit_show = true;
        }
        // 是领导，展示编辑反馈按钮
        if (this.alarm_info.supervisor === this.login_user.mis_id) {
          this.feedback_edit_show = true;
        }
        // 是领导，但用户尚未反馈
        if (this.alarm_info.supervisor !== this.alarm_info.recipient
          && this.alarm_info.supervisor === this.login_user.mis_id && this.alarm_info.rowStatus === 2) {
          this.appeal_result_show = true;
        }
        // 如果是领导，展示领导反馈
        if (this.alarm_info.supervisor === this.login_user.mis_id && this.alarm_info.supervisorFlag === 1 && this.alarm_info.rowStatus === 3) {
          this.feedback_show = true;
        }
        // 如果反馈不为空，展示已反馈内容
        if (this.alarm_info.appealReason != null && this.alarm_info.appealReason !== '') {
          this.appeal_result_show = true;
          this.appeal_user = this.alarm_info.appealUser;
        } else {
          this.appeal_user = this.alarm_info.recipient;
        }
        // 如果领导反馈不为空，展示领导反馈内容
        if (this.alarm_info.recipient.indexOf(this.login_user.mis_id) === -1 && this.alarm_info.feedbackReason != null && this.alarm_info.feedbackReason !== '') {
          this.feedback_result_show = true;
        }
        // 报表
        if (this.alarm_info.riskDetails != null && this.alarm_info.riskDetails !== '') {
          try {
            this.risk_details_mapping = JSON.parse(this.alarm_info.riskDetails).dataMapping;
            this.risk_details = JSON.parse(this.alarm_info.riskDetails).data;
            let temp = this.risk_details;
            let start = (this.currentPage - 1) * this.limit;
            let end = this.limit;
            this.risk_details_show = temp.slice(start,end);
          } catch (e) {
            console.log(e);
          }
        }
        if (this.alarm_info.riskSummary != null && this.alarm_info.riskSummary !== '') {
          try {
            this.risk_summary_mapping = JSON.parse(this.alarm_info.riskSummary).dataMapping;
            this.risk_summary = JSON.parse(this.alarm_info.riskSummary).data;
            if (this.risk_summary.length > 10) {
              this.risk_height = '400px';
            }
          } catch (e) {
            console.log(e);
          }
        }
        if (this.alarm_info.feedbackList && this.alarm_info.feedbackList.length > 0) {
          this.radioList = [];
          this.superiorRadioList = [];

          const feedbackList = this.alarm_info.feedbackList;
          if (feedbackList && feedbackList.length > 0) {
            feedbackList.forEach(item => {
              if (item.type === 0) {
                if (this.$i18nClient.getCurrentLocale() === 'en') {
                  this.radioList.push(item.enContent ?  item.enContent : item.content);
                } else {
                  this.radioList.push(item.content);
                }
              }
              if (item.type === 1) {
                if (this.$i18nClient.getCurrentLocale() === 'en') {
                  this.superiorRadioList.push(item.enContent ? item.enContent : item.content);
                } else {
                  this.superiorRadioList.push(item.content);
                }
              }
            })
          }
        } else {
          if (this.alarm_info.noticeConfig.feedbackLabelList) {
            this.radioList = this.alarm_info.noticeConfig.feedbackLabelList.split(',');
          }
          if (this.alarm_info.noticeConfig.supervisorFeedbackLabelList) {
            this.superiorRadioList = this.alarm_info.noticeConfig.supervisorFeedbackLabelList.split(',');
          }
        }

        this.$nextTick(() => {
          this.checkContentOverflow();
        });
      },
      handlePictureCardPreview (file) {
        this.previewImageUrl = file.url;
        this.previewVisible = true;
      },
      uploadToVenus(response, file) {
        if (response.code === 0) {
          file.url = response.data;
          this.files.push(file);
        } else {
          this.$mtd.message.error("上传失败");
        }
      },
      picturePreview(item) {
        this.activeImg = item;
        this.resultPreviewModal = true;
      },
      removePicture(file) {
        this.files.splice(this.files.indexOf(file), 1);
      },
      async submit_file_out() {
        let vm = this;
        let pictureUrl = [], formData = {};
        for (let i = 0; i < this.files.length; i++) {
          pictureUrl.push(this.files[i].url);
        }
        formData.appealType = this.appeal_type;
        formData.appealReason = this.appeal_other_reason;
        formData.pictures = pictureUrl.join(",");
        formData.sendObject = this.sendObject;
        formData.id = this.alarm_id;
        formData.appealFeedbackType = '0';
        formData.needPrivacyFeedback = this.alarm_info.needPrivacyFeedback;
        if (this.alarm_info.feedbackList &&  this.alarm_info.feedbackList.length > 0) {
          this.alarm_info.feedbackList.forEach(item => {
            if (item.type === 0 && (item.content === this.appeal_type || item.enContent === this.appeal_type)) {
              formData.appealFeedbackType = item.feedbackType;
              formData.invokePrivacy = item.invokePrivacy;
            }
          })
        }
        await this.api_update_reminders_inquiries(formData).then(function () {
          vm.init_data();
        });
      },
      back_alarms() {
        this.$router.push('/alarm');
      },
      async submit_appeal_reason() {
        let vm = this;
        if (this.appeal_reason === 0) {
          vm.$mtd.message.error('请选择原因');
          return;
        }
        if (this.appeal_other_reason === '') {
          vm.$mtd.message.error('请填写反馈详情');
          return;
        }

        let params = {id: this.alarm_id, appealUser: this.login_user.mis_id};
        params['appealType'] = this.appeal_type;
        params['appealReason'] = this.appeal_other_reason;
        params['appealFeedbackType'] = '0';
        params['needPrivacyFeedback'] = this.alarm_info.needPrivacyFeedback;
        if (this.alarm_info.feedbackList &&  this.alarm_info.feedbackList.length > 0) {
          this.alarm_info.feedbackList.forEach(item => {
            if (item.type === 0 && (item.content === this.appeal_type || item.enContent === this.appeal_type)) {
              params['appealFeedbackType'] = item.feedbackType;
              params['invokePrivacy'] = item.invokePrivacy;
            }
          })
        }
        await this.api_update_reminders_inquiries(params).then(function () {
          vm.init_data();
        });
      },
      async submit_feedback_reason() {
        let vm = this;
        if (this.feedback_reason === '') {
          vm.$mtd.message.error('请确认信息');
          return;
        }
        if (this.feedback_other_reason === '') {
          vm.$mtd.message.error('请填写确认信息');
          return;
        }

        let params = {id: this.alarm_id};
        params['feedbackReason'] = this.feedback_reason + '：' + this.feedback_other_reason;
        params['supervisorFeedback'] = this.feedback_reason;
        params['supervisorFeedbackType'] = '0';
        if (this.alarm_info.feedbackList &&  this.alarm_info.feedbackList.length > 0) {
          this.alarm_info.feedbackList.forEach(item => {
            if (item.type === 1 && (item.content === this.feedback_reason || item.enContent === this.feedback_reason)) {
              params['supervisorFeedbackType'] = item.feedbackType;
            }
          })
        }
        await this.api_update_reminders_inquiries(params).then(function () {
          vm.init_data();
        });
      },
      export_to_excel() {
        // 风险概览的文件
        let workSheet = XLSX.utils.json_to_sheet(this.risk_summary, {header: this.risk_summary_mapping.keys});
        // 日志抽样的数据
        let workSheet2 = XLSX.utils.json_to_sheet(this.risk_details, {header: this.risk_details_mapping.keys});
        const wb = XLSX.utils.book_new();
        const range = XLSX.utils.decode_range(workSheet['!ref']);
        const range2 = XLSX.utils.decode_range(workSheet2['!ref']);
        // 修改表头1
        for(let c = range.s.c; c <= range.e.c; c++) {
          const header = XLSX.utils.encode_col(c) + '1';
          workSheet[header].v = this.risk_summary_mapping[ workSheet[header].v ];
        }
        // 修改表头2
        for(let c = range2.s.c; c <= range2.e.c; c++) {
          const header = XLSX.utils.encode_col(c) + '1';
          workSheet2[header].v = this.risk_details_mapping[ workSheet2[header].v ];
        }

        XLSX.utils.book_append_sheet(wb, workSheet, "风险详情");
        XLSX.utils.book_append_sheet(wb, workSheet2, "明细日志");
        /* generate file and send to client */
        XLSX.writeFile(wb, "日志数据.xlsx");
      },
      editAppeal() {
        this.appeal_result_show = false;
        this.editAppealFlag = true;
        this.appeal_show = true;
        // 图片同步
        if (this.alarm_info.pictures) {
          let strings = this.alarm_info.pictures.split(',');
          this.files = [];
          strings.forEach(picture => {
            this.files.push({url: picture});
          });
        }
        this.sendObject = this.alarm_info.sendObject;
        this.appeal_type = this.alarm_info.appealType;
        this.appeal_other_reason = this.alarm_info.appealReason;
      },
      editCancel() {
        this.appeal_show = false;
        this.appeal_result_show = true;
      },
      editFeedback() {
        this.feedback_result_show = false;
        this.editFeedbackFlag = true;
        this.feedback_show = true;
        let array = this.alarm_info.feedbackReason.split("：");

        this.feedback_reason = array[0];
        this.feedback_other_reason = array[1];
      },
      editFeedbackCancel() {
        this.feedback_show = false;
        this.feedback_result_show = true;
      },
      onCopy() {
        this.$mtd.message.success("复制成功");
      },
      onError() {
        this.$mtd.message.error("复制失败");
      },
      getDescription(appeal_type, type) {
        if (this.alarm_info.feedbackList && this.alarm_info.feedbackList.length > 0) {
          const targetFeedback = this.alarm_info.feedbackList.find(
            feedback => feedback.type === type && (feedback.content === appeal_type || feedback.enContent === appeal_type)
          );

          if (!targetFeedback) {
            return '';
          }

          const isEnglish = this.$i18nClient.getCurrentLocale() === 'en';
          return isEnglish ? (targetFeedback.enExtra || targetFeedback.extra || '') : (targetFeedback.extra || '');
        }
        return '';
      },
      toggleContent() {
        this.showFullContent = !this.showFullContent;
      },
      checkContentOverflow() {
        const lineHeight = parseInt(getComputedStyle(this.$refs.contentWrapper).lineHeight, 10);
        const contentHeight = this.$refs.contentWrapper.scrollHeight;
        this.maxHeight = lineHeight * 20;
        if (contentHeight >= this.maxHeight) {
          this.isContentOverflow = true;
          this.showFullContent = false;
        }
      },
    },
  }
</script>

<style>
  .height-64 {
    height: 64px !important;
  }

  .line-height-64 {
    line-height: 64px !important;
  }

  .page-head-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0.5px;
    line-height: 28px;
  }

  .page-head-title-tag {
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 6px;
    margin-left: 8px;
  }

  .page-second-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.87);
    letter-spacing: 0;
    line-height: 22px;
  }

  .full-block-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    border: 1px solid rgba(0, 0, 0, 0.06);
  }

  .full-block-table .table-row {
    height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .none-height-table>.table-row {
    height: auto !important;
  }

  .full-block-table .table-row td {
    line-height: 36px;
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.60);
    letter-spacing: 0;
    padding: 0 12px;
    border-right: 1px solid rgba(0, 0, 0, 0.06);
    overflow: hidden;
    /*white-space: nowrap;*/
    /*text-overflow: ellipsis;*/
  }

  .full-block-table .table-row td.td-title {
    background: #F7F7F7;
    width: 90px;
  }

  .feedback-reason-block {
    background: #F7F7F7;
    border: 1px solid rgba(0, 0, 0, 0.07);
    padding: 15px;
    padding-bottom: 0;
  }
  .full-block-table .table-row td.alarm_info_content{
    white-space: normal;
    line-height: 20px;
  }
  .submit-helper {
    font-size: 12px;
    line-height: 20px;
    color: rgba(0,0,0,.36);
    margin-left: 4px;
  }
</style>
